import {
  AutoComplete,
  AutoCompleteCreatable,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
  AutoCompleteTag,
  Item,
  ItemTag,
} from "@choc-ui/chakra-autocomplete";
import classes from "./CreatableAutocomplete.module.css";
type CreatableAutocompleteProps = {
  options: Item[];
  placeholder?: string;
  values: string[];
  onChange: (value: Item) => void;
  onTagRemove: (tag: ItemTag) => void;
  id: string;
};
const CreatableAutocomplete = (props: CreatableAutocompleteProps) => {
  const { options, placeholder, id, onTagRemove, onChange, values } = props;

  return (
    <AutoComplete
      id={id}
      multiple
      creatable
      values={values}
      onSelectOption={(values) => onChange(values.item)}
      closeOnSelect
    >
      <AutoCompleteInput placeholder={placeholder} className={classes.input}>
        {({ tags }) =>
          tags.map((tag, tid) => (
            <AutoCompleteTag
              key={tid}
              label={tag.label}
              onRemove={() => onTagRemove(tag)}
            />
          ))
        }
      </AutoCompleteInput>
      <AutoCompleteList>
        {options.map((option, oid) => (
          <AutoCompleteItem
            key={`option-${oid}`}
            value={option.value}
            textTransform="capitalize"
          >
            {option.label || option.value}
          </AutoCompleteItem>
        ))}
        <AutoCompleteCreatable />
      </AutoCompleteList>
    </AutoComplete>
  );
};

export default CreatableAutocomplete;
